import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Home from '../views/Home.vue'
import UPR from '../views/UPR.vue'
import Product from '../views/Product.vue'
import MT from '../views/MT.vue'
import JC from '../views/JC.vue'
import NB from '../views/NB.vue'
import CJT from '../views/CJT.vue'
import HL from '../views/HL.vue'
import Login from '../views/Login.vue'
import MsgList from '../views/MsgList.vue'
import CallMe from '../views/CallMe.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'UPR',
        name: 'UPR',
        // component: UPR
        component: () => import(/* webpackChunkName: "upr" */ '../views/UPR.vue')
      },
      {
        path: 'Product',
        name: 'Product',
        // component: Product
        component: () => import(/* webpackChunkName: "product" */ '../views/Product.vue')
      },
      {
        path: 'MT',
        name: 'MT',
        // component: MT
        component: () => import(/* webpackChunkName: "mt" */ '../views/MT.vue')
      },
      {
        path: 'JC',
        name: 'JC',
        // component: JC
        component: () => import(/* webpackChunkName: "jc" */ '../views/JC.vue')
      },
      {
        path: 'NB',
        name: 'NB',
        // component: NB
        component: () => import(/* webpackChunkName: "nb" */ '../views/NB.vue')
      },
      {
        path: 'CJT',
        name: 'CJT',
        // component: CJT
        component: () => import(/* webpackChunkName: "cjt" */ '../views/CJT.vue')
      },
      {
        path: 'HL',
        name: 'HL',
        // component: HL
        component: () => import(/* webpackChunkName: "hl" */ '../views/HL.vue')
      },
      {
        path: 'CallMe',
        name: 'CallMe',
        component: CallMe
      }
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/MsgList',
    name: 'MsgList',
    component: MsgList
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
